//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            samples: [
                {
                    image: `iron_${this.$lang.locale}.png`,
                    correctDropAreaIndex: 0,
                    dropAreaIndex: -1
                },
                {
                    image: `magnesium_${this.$lang.locale}.png`,
                    correctDropAreaIndex: 1,
                    dropAreaIndex: -1
                },
                {
                    image: `nitrogen_${this.$lang.locale}.png`,
                    correctDropAreaIndex: 2,
                    dropAreaIndex: -1
                },
                {
                    image: `phosphor_${this.$lang.locale}.png`,
                    correctDropAreaIndex: 3,
                    dropAreaIndex: -1
                },
                {
                    image: `potassium_${this.$lang.locale}.png`,
                    correctDropAreaIndex: 4,
                    dropAreaIndex: -1
                }
            ],
            sampleOptions: {
                width: 156,
                height: 76
            },
            dropAreas: [
                {
                    xMin: 565,
                    xMax: 721,
                    yMin: 216,
                    yMax: 292
                },
                {
                    xMin: 433,
                    xMax: 589,
                    yMin: 312,
                    yMax: 388
                },
                {
                    xMin: 44,
                    xMax: 200,
                    yMin: 215,
                    yMax: 291
                },
                {
                    xMin: 172,
                    xMax: 328,
                    yMin: 312,
                    yMax: 388
                },
                {
                    xMin: 306,
                    xMax: 462,
                    yMin: 215,
                    yMax: 291
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.samples.filter(sample => sample.correctDropAreaIndex === sample.dropAreaIndex).length;

            return this.$game.getDragDropResult(numCorrect, this.samples.length - numCorrect);
        }
    },

    created () {
        this.samples = this.samples.map((sample, index) => ({
            ...sample,
            x: 850 + (Math.random() * 15),
            y: 605 - (index * this.sampleOptions.height)
        }));
    },

    methods: {
        dragend (sample, { x, y }) {
            this.showHoverBg = false;

            sample.x = x;
            sample.y = y;
            sample.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                sample.x >= area.xMin - this.sampleOptions.width / 2 &&
                sample.x <= area.xMax - this.sampleOptions.width / 2 &&
                sample.y >= area.yMin - this.sampleOptions.height / 2 &&
                sample.y <= area.yMax - this.sampleOptions.height / 2
            );

            if (sample.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    sample.x = this.dropAreas[sample.dropAreaIndex].xMin;
                    sample.y = this.dropAreas[sample.dropAreaIndex].yMin;
                });
            }
        }
    }
};
